<template>
    <p>
        <DsCurlyQuotes>Just some quoted text.</DsCurlyQuotes>
    </p>

    <p>
        <DsCurlyQuotes>All <em>work</em> and no <strong>play</strong> make "{{ firstName }}" a dull boy.</DsCurlyQuotes>
    </p>

    <p class="text-3xl font-bold">
        <DsCurlyQuotes>Large &amp; bold</DsCurlyQuotes>
    </p>

    <p class="text-sm italic text-ds-primary-600">
        <DsCurlyQuotes>Small, italic, colored</DsCurlyQuotes>
    </p>

    <p>
        The instructions said to enter <DsCurlyQuotes>For benefit of</DsCurlyQuotes> in the memo, then confirm the
        <DsCurlyQuotes>FFC: {{ firstName }} 123456789</DsCurlyQuotes> reference number.
    </p>
</template>

<script setup lang="ts">
import DsCurlyQuotes from '@ds/DsCurlyQuotes.vue';
import { ref } from 'vue';

const firstName = ref('Jack');
</script>

<style lang="scss" scoped>
p {
    @apply mt-4;
}
</style>
